import React from 'react';
import { CombosHintContainer } from './styled';
import Text from '../../../ui/Text';
import CloseButton from '../../../components/CloseButton/CloseButton';

const CombosHint = ({ close }) => {
    return (
        <CombosHintContainer>
            <CloseButton
                bC={'rgba(255255, 255, 255, 0.2)'}
                iconColor={'#BFC9D9'}
                right={'15px'}
                top={'25px'}
                click={close}
            />
            <Text
                size={'13'}
                lh={'20'}
                margin={'0'}
                padding={'0'}
                capitalize
                color={'#FDD804'}
            >
                NYHED!
            </Text>
            <Text
                size={'20'}
                lh={'22'}
                margin={'22px 0 0'}
                padding={'0'}
                color={'#fff'}
                fontFamily={'ATG Rubik'}
            >
                Hvad spiller andre lige nu?
            </Text>
            <Text
                size={'13'}
                lh={'20'}
                margin={'16px 0 0'}
                padding={'0'}
                color={'#fff'}
            >
                Få inspiration fra de mest populære kombispil købt af andre
                spillere
            </Text>
        </CombosHintContainer>
    );
};

export default CombosHint;
